import React from 'react';

import {FloatingArrow, FloatingArrowProps} from '@floating-ui/react';

import {COMMON_COLORS} from 'client/common/colors';

export type PopoverArrowProps = FloatingArrowProps & {
  variant?: 'dark' | 'light' | 'tooltip' | 'editor';
};

const DEFAULT_ARROW_CONFIG = {
  fill: 'currentColor',
  stroke: '#667893',
  tipRadius: 1,
  width: 15,
  height: 5,
};

const PopoverArrow = React.forwardRef<SVGSVGElement, PopoverArrowProps>(({variant = 'light', ...props}, ref) => {
  let fill = 'white';
  if (variant === 'dark') {
    fill = COMMON_COLORS.TEXT_NORMAL;
  } else if (variant === 'tooltip') {
    fill = 'var(--color-brand-blue-2)';
  } else if (variant === 'editor') {
    fill = COMMON_COLORS.EDITOR;
  }

  const exterArrowConfig = {
    ...DEFAULT_ARROW_CONFIG,
    fill,
    ...props,
  };

  return <FloatingArrow {...exterArrowConfig} ref={ref} />;
});

export default PopoverArrow;
